import request from "@/utils/request";

// ic卡数据导入 
export function cardImport(data) {
  return request({
    url: "/card/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}




// ic卡删除 gradeDelete
export function cardDelete(data) {
  return request({
    url: "/card/delete",
    method: "post",
    params: { ...data },
  });
}


// 模版下载 /card/downloadTemplate
export function ICDownloadTemplate() {
  return request({
    url: "/card/downloadTemplate",
    method: "post",
    responseType: "blob",
  });
}

// 新增
export function cardAdd(data) {
  return request({
    url: "card/add",
    method: "post",
    data,
  });
}

// 删除儿童
export function childDelete(data) {
  return request({
    url: "/child/delete",
    method: "post",
    params: { ...data },
  });
}


// 儿童新增
export function childAddOrEdit(data) {
  return request({
    url: "/child/addOrEdit",
    method: "post",
    data,
  });
}

// 所有的mac卡信息 /card/page
export function cardPage(data) {
  return request({
    url: "/card/page",
    method: "post",
    data,
  });
}


// 退学 
export function childrenQuit(data) {
  return request({
    url: "/child/quit",
    method: "post",
    params: { ...data },
  });
}


// 查看儿童信息 
export function childrenList(data) {
  return request({
    url: "/child/page",
    method: "post",
    data,
  });
}
// 职工详情
export function staffDetail(data) {
  return request({
    url: "/user/detail",
    method: "post",
    params: { ...data },
  });
}


// 角色列表的接口 /role/page
export function rolePage(data) {
  return request({
    url: "/role/page",
    method: "post",
    data,
  });
}

// 文件上传接口
export function fileUpload(data) {
  return request({
    url: "/file/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

